//sadnand_gadwal

import {
  GET_BOOKING,
  GET_CUSTOMER_ORGANIZATION,
  GET_CUSTOMER_WORK_EXPERIENCE,
  GET_CUSTOMER_WORK_SECTOR,
  GET_CUSTOMER_INCOME,
  GET_COUNTRY_OF_RESIDENCE,
  GET_COUNTRY_OF_CITIZENSHIP,
  GET_MOTHER_TONGUE,
  GET_MARITAL_STATUS,
  GET_CUSTOMER_PURCHASE_REASON,
  GET_CUSTOMER_CONSTRUCTION_PLANNING,
  GET_CUSTOMER_WORK_FUNCTION,
  GET_ENQUIRY_SOURCE,
  GET_ENQUIRY_SOURCE_NEWSPAPER,
  GET_ENQUIRY_SOURCE_SOCIAL_MEDIA,
  GET_CUSTOMER_EMPLOYMENT_TYPE,
  GET_CUSTOMER_CURRENT_LIVING,
  GET_CUSTOMER_CRITICAL_FACTOR,
  GET_CUSTOMER_SUITABLE_TIME,
  GET_SALES_ORDER_ITEM,
  GET_SALES_INVOICE,
  GET_SALES_INVOICE_FILTER_COMPANY,
  GET_SALES_INVOICE_DETAIL,
  GET_SALES_ACCOUNTNG,
  GET_SALES_ACCOUNTNG_FILTER_PROJECT,
  GET_SALES_ACCOUNTNG_DETAIL,
  GET_SALES_ACCOUNTNG_FOR_INOVICE,
  GET_SALES_ACCOUNTNG_EXPORT,
  GET_SALES_INVOICE_FILTER_PROJECT,
  GET_SALES_ORDER_PAYMENT_SCHEDULE,
  GET_REFERRAL_FOR_SALES_ORDER,
  // ---------------------------------CLP--------------------------------------------
  // ---------------------------------END-CLP--------------------------------------------
  GET_CUSTOMER,
  GET_CUSTOMER_EXPORT,
  GET_CUSTOMER_DETAIL,
  // SalesPlan
  GET_ITEM_FOR_SALES_PLAN,
  GET_SALES_PLAN,
  GET_SALES_PLAN_EXPORT,
  GET_SALES_PLAN_DETAILS,
  GET_MARKETING_PLAN_ITEM,
  GET_SALES_INVOICE_EXPORT,
  GET_SALES_REFERRAL,
  GET_SALES_REFERRAL_DETAIL,
  GET_SALES_REFERRAL_EXPORT,
  GET_SALES_REFERRAL_FILTER_PROJECT,
  GET_SALES_REFERRAL_PRINT,
  GET_REFERRAL_PRINT,
  GET_SALES_REFERRAL_BILL,
  GET_SALES_REFERRAL_BILL_EXPORT,
  GET_SALES_REFERRAL_BILL_DETAIL,
  GET_SALES_REFERRAL_BILL_FILTER_PROJECT,
  GET_SALES_REFERRAL_BILL_FILTER_VENDOR,
  GET_SALES_REFERRAL_BILL_FILTER_COMPANY,
  GET_SALES_REFERRAL_FILTER_REFERRER,
  GET_SALES_REFFERAL_LIST,
  GET_SALES_REFFERAL_CP_LIST,
  GET_LAND_CONSULTANT,
  GET_LAND_CONSULTANT_EXPORT,
  GET_LAND_CONSULTANT_DETAIL,
  GET_ITEM_FOR_SALES_REFERRAL,
  GET_ENQUIRY_MATCH_LIST,
  GET_PROJECT_FOR_SALES_ORDER,
  GET_SITE_FOR_BOOKING,
  GET_SITE_COST_FOR_BOOKING,
  GET_CUSTOMER_INFO_FOR_BOOKING,
  GET_SALES_BOOKING,
  GET_SITE_SELECTION_DETAIL_FOR_BOOKING,
  GET_SALES_BOOKING_DETAILS,
  GET_SALES_BOOKING_EXPORT,

  //Sales Order
  GET_LEAD_FOR_SALES_ORDER,
  GET_LEAD_DETAIL_FOR_SALES_ORDER,
  GET_PROJECT_FOR_SALES_ORDER1,
  GET_SITE_FOR_SALES_ORDER,
  GET_FACING_FOR_SALES_ORDER,
  GET_DIMENSION_FOR_SALES_ORDER,
  GET_SITE_DETAIL_FOR_SALES_ORDER,
  GET_SALES_ORDER,
  GET_SALES_ORDER_EXPORT,
  GET_SALES_ORDER_FILTER_PROJECT,
  GET_SALES_ORDER_FILTER_SITE_NUMBER,
  GET_SALES_ORDER_FILTER_BOOKED_USER,
  GET_SALES_ORDER_FILTER_CRM_USER,
  GET_SALES_ORDER_FILTER_BOOKING_STATUS,
  GET_SALES_ORDER_FILTER_SITE_STATUS,
  GET_SALES_ORDER_DETAIL,
  GET_SALES_ORDER_PAYMENT_INFO,
  GET_CUSTOMER_DETAIL_FOR_SALES_ORDER,
  GET_RELATIONSHIP_FOR_SALES_ORDER,
  GET_SALES_ORDER_CUSTOMER,
  GET_SALES_ORDER_PAYMENT,
  GET_BANK_FOR_SALES_ORDER,
  GET_SALES_ORDER_REJECTION_REASON,
  CREATE_SALES_ORDER,
  CREATE_CUSTOMER_FOR_SALES_ORDER,
  UPDATE_CUSTOMER_FOR_SALES_ORDER,
  GET_CUSTOMER_DETAIL_FOR_SALES_ORDER_FOR_APPLICANT,
  //sales cancellation
  GET_SALES_CANCELLATION,
  GET_SALES_CANCELLATION_DETAIL,
  GET_SALES_CANCELLATION_EXPORT,
  GET_SALES_CANCELLATION_FILTER_STATUS,
  GET_SALES_CANCELLATION_FILTER_PROJECT,
  GET_SALES_CANCELLATION_FILTER_REASON,
  GET_SALES_CANCELLATION_FILTER_SITE,
  GET_SALES_CANCELLATION_FILTER_CRM_USER,
  GET_SALES_CANCELLATION_FILTER_STM_USER,
  // Sales Incentive Plan
  GET_SALES_INCENTIVE_PLAN,
  GET_SALES_INCENTIVE_PLAN_EXPORT,
  GET_SALES_INCENTIVE_PLAN_DETAIL,
  GET_ITEM_FOR_SALES_INCENTIVE,
  GET_INCENTIVE,
  GET_INCENTIVE_DETAIL,
  GET_INCENTIVE_FILTER_EMPLOYEE,
  // Sales Referral Slab
  GET_SALES_REFERRAL_SLAB,
  GET_SALES_REFERRAL_SLAB_EXPORT,
  //Sales Order Quotation
  CREATE_SALES_BOOKING_QUOTATION,
  GET_SALES_BOOKING_QUOTATION,
  GET_SALES_BOOKING_QUOTATION_EXPORT,
  GET_SALES_BOOKING_QUOTATION_DETAIL,
  GET_SALES_BOOKING_QUOTATION_FILTER_PROJECT,
  GET_SALES_BOOKING_QUOTATION_FILTER_SITE,
  GET_CUSTOMER_ACCOUNT,
  GET_SALES_PROJECT_STM,
  GET_SALES_PROJECT_STM_DETAIL,
  GET_USER_AVAILABILITY,
  GET_USER_AVAILABILITY_DETAIL,
  GET_USER_DEPARTMENT_FILTER,
  GET_SALES_PROJECT_STM_PROJECT_FILTER,
  GET_USER_AVILABILITY_FILTER,
  GET_SALES_PROJECT_STM_USER_FILTER,
} from "./types";

const initialState = {
  getBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerOrganization: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkExperience: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkSector: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerIncome: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCountryOfResidence: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCountryOfCitizenship: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getMotherTongue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getMaritalStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerConstructionPlanning: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerPurchaseReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkFunction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  enquirySourceList: {
    error: false,
    message: "",
    data: [],
  },
  getEnquirySourceNewsPaper: [],
  getEnquirySourceSocialMedia: [],
  getCustomerEmploymentType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerCurrentLiving: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerCriticalFactor: [],
  getCustomerSuitableTime: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //sales invoice
  getSalesOrderItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesInvoice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesInvoiceFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesInvoiceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //sales accounting
  getSalesAccounting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesAccountingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesAccountingFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesAccountingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesAccountingForInvoice: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesInvoiceFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderPaymentSchedule: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getReferralForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //   // -----------------------CLP-----------------------------

  // -----------------------END-CLP-----------------------------

  getCustomer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getItemForSalesPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesPlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getMarketingPlanItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesInvoiceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //SALES REFERRAL
  getSalesReferral: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getItemForSalesReferral: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralFilterReferrer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getSalesReferralPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getReferralPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getSalesReferralBill: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralBillExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralBillDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralBillFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralBillFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralBillFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralCpList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLandConsultant: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLandConsultantExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLandConsultantDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //Live Booking
  getEnquiryMatchList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteForBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteCostForBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerInfoForBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteSelectionDetailForBooking: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  //Sales Order
  getLeadForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadDetailForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectForSalesOrder1: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getFacingForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getDimensionForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteDetailForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterSiteNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterBookedUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterCrmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterBookingStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderFilterSiteStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderPaymentInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerDetailForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerDetailForSalesOrderForApplicant: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getRelationshipForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderCustomer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderPayment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBankForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesOrderRejectionReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  createSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  createCustomerForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  updateCustomerForSalesOrder: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //sales cancellation
  getSalesCancellation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterCrmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterStmUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesCancellationFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  // Sales Incentive Plan
  getSalesIncentivePlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesIncentivePlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesIncentivePlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getItemForSalesBookingIncentive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getIncentive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getIncentiveDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getIncentiveFilterEmployee: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  // sales Referal Slab
  getSalesReferralSlab: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesReferralSlabExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //Sales Order Quotation
  createSalesBookingQuotation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingQuotation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingQuotationExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingQuotationDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingQuotationFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesBookingQuotationFilterSite: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerAccount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesProjectStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesProjectStmDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getUserAvailability: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getUserAvailabilityDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getUserDepartmentFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getSalesProjectSTMProjectFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getUserAvailabilityFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSalesProjectSTMUserFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
};
const Sales_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BOOKING:
      return Object.assign({}, state, { getBooking: payload });

    case GET_CUSTOMER_ORGANIZATION:
      return Object.assign({}, state, { getCustomerOrganization: payload });

    case GET_CUSTOMER_WORK_EXPERIENCE:
      return Object.assign({}, state, { getCustomerWorkExperience: payload });

    case GET_CUSTOMER_WORK_SECTOR:
      return Object.assign({}, state, { getCustomerWorkSector: payload });

    case GET_CUSTOMER_INCOME:
      return Object.assign({}, state, { getCustomerIncome: payload });

    case GET_COUNTRY_OF_RESIDENCE:
      return Object.assign({}, state, { getCountryOfResidence: payload });
    case GET_COUNTRY_OF_CITIZENSHIP:
      return Object.assign({}, state, { getCountryOfCitizenship: payload });
    case GET_MOTHER_TONGUE:
      return Object.assign({}, state, { getMotherTongue: payload });
    case GET_MARITAL_STATUS:
      return Object.assign({}, state, { getMaritalStatus: payload });

    case GET_CUSTOMER_CONSTRUCTION_PLANNING:
      return Object.assign({}, state, {
        getCustomerConstructionPlanning: payload,
      });
    case GET_CUSTOMER_PURCHASE_REASON:
      return Object.assign({}, state, { getCustomerPurchaseReason: payload });

    case GET_CUSTOMER_WORK_FUNCTION:
      return Object.assign({}, state, { getCustomerWorkFunction: payload });

    case GET_ENQUIRY_SOURCE:
      return Object.assign({}, state, { enquirySourceList: payload });
    case GET_ENQUIRY_SOURCE_NEWSPAPER:
      return Object.assign({}, state, { getEnquirySourceNewsPaper: payload });
    case GET_ENQUIRY_SOURCE_SOCIAL_MEDIA:
      return Object.assign({}, state, { getEnquirySourceSocialMedia: payload });
    case GET_CUSTOMER_EMPLOYMENT_TYPE:
      return Object.assign({}, state, { getCustomerEmploymentType: payload });
    case GET_CUSTOMER_CURRENT_LIVING:
      return Object.assign({}, state, { getCustomerCurrentLiving: payload });
    case GET_CUSTOMER_CRITICAL_FACTOR:
      return Object.assign({}, state, { getCustomerCriticalFactor: payload });
    case GET_CUSTOMER_SUITABLE_TIME:
      return Object.assign({}, state, { getCustomerSuitableTime: payload });
    //sales invoice
    case GET_SALES_ORDER_ITEM:
      return Object.assign({}, state, { getSalesOrderItem: payload });
    case GET_SALES_INVOICE:
      return Object.assign({}, state, { getSalesInvoice: payload });
    case GET_SALES_INVOICE_FILTER_COMPANY:
      return Object.assign({}, state, {
        getSalesInvoiceFilterCompany: payload,
      });
    case GET_SALES_INVOICE_DETAIL:
      return Object.assign({}, state, { getSalesInvoiceDetail: payload });
    //sales accounting
    case GET_SALES_ACCOUNTNG:
      return Object.assign({}, state, { getSalesAccounting: payload });
    case GET_SALES_ACCOUNTNG_EXPORT:
      return Object.assign({}, state, { getSalesAccountingExport: payload });
    case GET_SALES_ACCOUNTNG_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesAccountingFilterProject: payload,
      });
    case GET_SALES_ACCOUNTNG_DETAIL:
      return Object.assign({}, state, { getSalesAccountingDetail: payload });
    case GET_SALES_ACCOUNTNG_FOR_INOVICE:
      return Object.assign({}, state, {
        getSalesAccountingForInvoice: payload,
      });
    case GET_SALES_INVOICE_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesInvoiceFilterProject: payload,
      });
    case GET_SALES_ORDER_PAYMENT_SCHEDULE:
      return Object.assign({}, state, {
        getSalesOrderPaymentSchedule: payload,
      });
    case GET_REFERRAL_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getReferralForSalesOrder: payload,
      });
    // -----------------------CLP-----------------------------

    // ---------------------------------END-CLP------------------------------------

    case GET_CUSTOMER:
      return Object.assign({}, state, { getCustomer: payload });
    case GET_CUSTOMER_EXPORT:
      return Object.assign({}, state, { getCustomerExport: payload });
    case GET_CUSTOMER_DETAIL:
      return Object.assign({}, state, { getCustomerDetail: payload });
    case GET_ITEM_FOR_SALES_PLAN:
      return Object.assign({}, state, {
        getItemForSalesPlan: payload,
      });
    case GET_SALES_PLAN:
      return Object.assign({}, state, {
        getSalesPlan: payload,
      });
    case GET_SALES_PLAN_EXPORT:
      return Object.assign({}, state, {
        getSalesPlanExport: payload,
      });
    case GET_SALES_PLAN_DETAILS:
      return Object.assign({}, state, {
        getSalesPlanDetail: payload,
      });
    case GET_MARKETING_PLAN_ITEM:
      return Object.assign({}, state, {
        getMarketingPlanItem: payload,
      });

    case GET_SALES_INVOICE_EXPORT:
      return Object.assign({}, state, {
        getSalesInvoiceExport: payload,
      });
    //SALES REFFEREAL
    case GET_SALES_REFERRAL:
      return Object.assign({}, state, {
        getSalesReferral: payload,
      });
    case GET_ITEM_FOR_SALES_REFERRAL:
      return Object.assign({}, state, {
        getItemForSalesReferral: payload,
      });
    case GET_SALES_REFERRAL_FILTER_REFERRER:
      return Object.assign({}, state, {
        getSalesReferralFilterReferrer: payload,
      });
    case GET_SALES_REFERRAL_EXPORT:
      return Object.assign({}, state, {
        getSalesReferralExport: payload,
      });
    case GET_SALES_REFERRAL_DETAIL:
      return Object.assign({}, state, {
        getSalesReferralDetail: payload,
      });

    case GET_SALES_REFERRAL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReferralFilterProject: payload,
      });

    case GET_SALES_REFERRAL_PRINT:
      return Object.assign({}, state, {
        getSalesReferralPrint: payload,
      });
    case GET_REFERRAL_PRINT:
      return Object.assign({}, state, {
        getReferralPrint: payload,
      });
    case GET_SALES_REFERRAL_BILL_DETAIL:
      return Object.assign({}, state, { getSalesReferralBillDetail: payload });
    case GET_SALES_REFERRAL_BILL:
      return Object.assign({}, state, { getSalesReferralBill: payload });
    case GET_SALES_REFERRAL_BILL_EXPORT:
      return Object.assign({}, state, { getSalesReferralBillExport: payload });
    case GET_SALES_REFERRAL_BILL_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesReferralBillFilterProject: payload,
      });
    case GET_SALES_REFERRAL_BILL_FILTER_VENDOR:
      return Object.assign({}, state, {
        getSalesReferralBillFilterVendor: payload,
      });
    case GET_SALES_REFERRAL_BILL_FILTER_COMPANY:
      return Object.assign({}, state, {
        getSalesReferralBillFilterCompany: payload,
      });
    case GET_SALES_REFFERAL_LIST:
      return Object.assign({}, state, {
        getSalesReferralList: payload,
      });

    case GET_SALES_REFFERAL_CP_LIST:
      return Object.assign({}, state, {
        getSalesReferralCpList: payload,
      });
    case GET_LAND_CONSULTANT:
      return Object.assign({}, state, {
        getLandConsultant: payload,
      });
    case GET_LAND_CONSULTANT_EXPORT:
      return Object.assign({}, state, {
        getLandConsultantExport: payload,
      });
    case GET_LAND_CONSULTANT_DETAIL:
      return Object.assign({}, state, {
        getLandConsultantDetail: payload,
      });
    //Live Booking
    case GET_ENQUIRY_MATCH_LIST:
      return Object.assign({}, state, {
        getEnquiryMatchList: payload,
      });
    case GET_PROJECT_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getProjectForSalesOrder: payload,
      });
    case GET_SITE_FOR_BOOKING:
      return Object.assign({}, state, {
        getSiteForBooking: payload,
      });
    case GET_SITE_COST_FOR_BOOKING:
      return Object.assign({}, state, {
        getSiteCostForBooking: payload,
      });
    case GET_CUSTOMER_INFO_FOR_BOOKING:
      return Object.assign({}, state, {
        getCustomerInfoForBooking: payload,
      });
    case GET_SALES_BOOKING:
      return Object.assign({}, state, {
        getSalesBooking: payload,
      });
    case GET_SALES_BOOKING_EXPORT:
      return Object.assign({}, state, {
        getSalesBookingExport: payload,
      });
    case GET_SITE_SELECTION_DETAIL_FOR_BOOKING:
      return Object.assign({}, state, {
        getSiteSelectionDetailForBooking: payload,
      });
    case GET_SALES_BOOKING_DETAILS:
      return Object.assign({}, state, {
        getSalesBookingDetail: payload,
      });

    //Sales Order
    case GET_LEAD_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getLeadForSalesOrder: payload,
      });
    case GET_LEAD_DETAIL_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getLeadDetailForSalesOrder: payload,
      });
    case GET_PROJECT_FOR_SALES_ORDER1:
      return Object.assign({}, state, {
        getProjectForSalesOrder1: payload,
      });
    case GET_SITE_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getSiteForSalesOrder: payload,
      });
    case GET_FACING_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getFacingForSalesOrder: payload,
      });
    case GET_DIMENSION_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getDimensionForSalesOrder: payload,
      });
    case GET_SITE_DETAIL_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getSiteDetailForSalesOrder: payload,
      });
    case GET_SALES_ORDER:
      return Object.assign({}, state, {
        getSalesOrder: payload,
      });
    case GET_SALES_ORDER_EXPORT:
      return Object.assign({}, state, {
        getSalesOrderExport: payload,
      });
    case GET_SALES_ORDER_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesOrderFilterProject: payload,
      });
    case GET_SALES_ORDER_FILTER_SITE_NUMBER:
      return Object.assign({}, state, {
        getSalesOrderFilterSiteNumber: payload,
      });
    case GET_SALES_ORDER_FILTER_BOOKED_USER:
      return Object.assign({}, state, {
        getSalesOrderFilterBookedUser: payload,
      });
    case GET_SALES_ORDER_FILTER_CRM_USER:
      return Object.assign({}, state, {
        getSalesOrderFilterCrmUser: payload,
      });
    case GET_SALES_ORDER_FILTER_BOOKING_STATUS:
      return Object.assign({}, state, {
        getSalesOrderFilterBookingStatus: payload,
      });
    case GET_SALES_ORDER_FILTER_SITE_STATUS:
      return Object.assign({}, state, {
        getSalesOrderFilterSiteStatus: payload,
      });
    case GET_SALES_ORDER_DETAIL:
      return Object.assign({}, state, {
        getSalesOrderDetail: payload,
      });
    case GET_SALES_ORDER_PAYMENT_INFO:
      return Object.assign({}, state, {
        getSalesOrderPaymentInfo: payload,
      });
    case GET_CUSTOMER_DETAIL_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getCustomerDetailForSalesOrder: payload,
      });
    case GET_CUSTOMER_DETAIL_FOR_SALES_ORDER_FOR_APPLICANT:
      return Object.assign({}, state, {
        getCustomerDetailForSalesOrderForApplicant: payload,
      });
    case GET_RELATIONSHIP_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getRelationshipForSalesOrder: payload,
      });

    case GET_SALES_ORDER_CUSTOMER:
      return Object.assign({}, state, {
        getSalesOrderCustomer: payload,
      });

    case GET_SALES_ORDER_PAYMENT:
      return Object.assign({}, state, {
        getSalesOrderPayment: payload,
      });
    case GET_BANK_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        getBankForSalesOrder: payload,
      });

    case GET_SALES_ORDER_REJECTION_REASON:
      return Object.assign({}, state, {
        getSalesOrderRejectionReason: payload,
      });

    case CREATE_SALES_ORDER:
      return Object.assign({}, state, {
        createSalesOrder: payload,
      });
    case CREATE_CUSTOMER_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        createCustomerForSalesOrder: payload,
      });
    case UPDATE_CUSTOMER_FOR_SALES_ORDER:
      return Object.assign({}, state, {
        updateCustomerForSalesOrder: payload,
      });

    //sales cancellation
    case GET_SALES_CANCELLATION:
      return Object.assign({}, state, {
        getSalesCancellation: payload,
      });
    case GET_SALES_CANCELLATION_DETAIL:
      return Object.assign({}, state, {
        getSalesCancellationDetail: payload,
      });
    case GET_SALES_CANCELLATION_EXPORT:
      return Object.assign({}, state, {
        getSalesCancellationExport: payload,
      });
    case GET_SALES_CANCELLATION_FILTER_STATUS:
      return Object.assign({}, state, {
        getSalesCancellationFilterStatus: payload,
      });
    case GET_SALES_CANCELLATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesCancellationFilterProject: payload,
      });
    case GET_SALES_CANCELLATION_FILTER_REASON:
      return Object.assign({}, state, {
        getSalesCancellationFilterReason: payload,
      });
    case GET_SALES_CANCELLATION_FILTER_SITE:
      return Object.assign({}, state, {
        getSalesCancellationFilterSite: payload,
      });
    case GET_SALES_CANCELLATION_FILTER_CRM_USER:
      return Object.assign({}, state, {
        getSalesCancellationFilterCrmUser: payload,
      });

    case GET_SALES_CANCELLATION_FILTER_STM_USER:
      return Object.assign({}, state, {
        getSalesCancellationFilterStmUser: payload,
      });
    // Sales Incentive Plan
    case GET_SALES_INCENTIVE_PLAN:
      return Object.assign({}, state, {
        getSalesIncentivePlan: payload,
      });
    case GET_SALES_INCENTIVE_PLAN_EXPORT:
      return Object.assign({}, state, { getSalesIncentivePlanExport: payload });
    case GET_SALES_INCENTIVE_PLAN_DETAIL:
      return Object.assign({}, state, { getSalesIncentivePlanDetail: payload });
    case GET_ITEM_FOR_SALES_INCENTIVE:
      return Object.assign({}, state, {
        getItemForSalesBookingIncentive: payload,
      });
    case GET_INCENTIVE:
      return Object.assign({}, state, {
        getIncentive: payload,
      });
    case GET_INCENTIVE_DETAIL:
      return Object.assign({}, state, {
        getIncentiveDetail: payload,
      });
    case GET_INCENTIVE_FILTER_EMPLOYEE:
      return Object.assign({}, state, {
        getIncentiveFilterEmployee: payload,
      });
    // Sales Referal Slab
    case GET_SALES_REFERRAL_SLAB:
      return Object.assign({}, state, {
        getSalesReferralSlab: payload,
      });
    case GET_SALES_REFERRAL_SLAB_EXPORT:
      return Object.assign({}, state, {
        getSalesReferralSlabExport: payload,
      });

    //Sales Order Quotation
    case CREATE_SALES_BOOKING_QUOTATION:
      return Object.assign({}, state, {
        createSalesBookingQuotation: payload,
      });
    case GET_SALES_BOOKING_QUOTATION:
      return Object.assign({}, state, {
        getSalesBookingQuotation: payload,
      });
    case GET_SALES_BOOKING_QUOTATION_EXPORT:
      return Object.assign({}, state, {
        getSalesBookingQuotationExport: payload,
      });
    case GET_SALES_BOOKING_QUOTATION_DETAIL:
      return Object.assign({}, state, {
        getSalesBookingQuotationDetail: payload,
      });
    case GET_SALES_BOOKING_QUOTATION_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSalesBookingQuotationFilterProject: payload,
      });
    case GET_SALES_BOOKING_QUOTATION_FILTER_SITE:
      return Object.assign({}, state, {
        getSalesBookingQuotationFilterSite: payload,
      });
    case GET_CUSTOMER_ACCOUNT:
      return Object.assign({}, state, {
        getCustomerAccount: payload,
      });
    case GET_SALES_PROJECT_STM:
      return Object.assign({}, state, {
        getSalesProjectStm: payload,
      });
    case GET_SALES_PROJECT_STM_DETAIL:
      return Object.assign({}, state, {
        getSalesProjectStmDetail: payload,
      });

    case GET_USER_AVAILABILITY:
      return Object.assign({}, state, {
        getUserAvailability: payload,
      });

    case GET_USER_AVAILABILITY_DETAIL:
      return Object.assign({}, state, {
        getUserAvailabilityDetail: payload,
      });

    case GET_USER_DEPARTMENT_FILTER:
      return Object.assign({}, state, {
        getUserDepartmentFilter: payload,
      });

    case GET_SALES_PROJECT_STM_PROJECT_FILTER:
      return Object.assign({}, state, {
        getSalesProjectSTMProjectFilter: payload,
      });

    case GET_USER_AVILABILITY_FILTER:
      return Object.assign({}, state, {
        getUserAvailabilityFilter: payload,
      });

    case GET_SALES_PROJECT_STM_USER_FILTER:
      return Object.assign({}, state, {
        getSalesProjectSTMUserFilter: payload,
      });
    default:
      return state;
  }
};
export default Sales_reducer;
